import { notify, TYPE } from '@8x8/oxygen-toaster'

const DURATION = 6000

let notification
const notifyWrapper = (title, type) => {
  if (type === TYPE.error) {
    return notify({
      content: title,
      type: TYPE.error,
      duration: DURATION
    }
    )
  }

  return notify({
    content: title,
    type: TYPE.success,
    duration: DURATION
  }
  )
}

export const showErrorNotification = title => {
  notification = notifyWrapper(title, TYPE.error)
  return notification
}

export const showInlineNotification = title => {
  notification = notifyWrapper(title, TYPE.success)
}
